export default __webpack_public_path__ + "static/media/miniLogo.3e7baeb9.svg";